import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import styles from "./styles";
import Draggable from "react-draggable";
import { Grid, Typography } from "@material-ui/core";

const DraggableLabel = (props) => {
  const {
    showDraggable,
    onDragStart,
    onDragEnd,
    onDragUpdate,
    setDraggableLabel,
    label,
    currentQuestion,
    dragStarted,
    classes,
    image,
    left
  } = props;

  return (
    <Draggable
      onDrag={onDragUpdate}
      onStart={() => setDraggableLabel(label)}
      onStop={onDragEnd}
      defaultPosition={{ x: 0, y: 0 }}
      position={{ x: 0, y: 0 }}
    >
      <Grid container className={classes.dragableDiv}>
        <Grid container className={classes.shadowDiv} />

        <Grid container className={classes.textContainer}>
          <Typography className={classes.text}>{label}</Typography>
        </Grid>
      </Grid>
      {/* <img src={image} alt="PriceLabel" style={{ height: 50, position: "relative", [left && "left"]: left, zIndex: 1, cursor: "pointer" }}/> */}
    </Draggable>
  );
};

export default withStyles(styles)(DraggableLabel);
